import {CALL_API} from '../../middleware/api';

export const GET_MOBILE_CODE_REQUEST = 'GET_MOBILE_CODE_REQUEST';
export const GET_MOBILE_CODE_SUCCESS = 'GET_MOBILE_CODE_SUCCESS';
export const GET_MOBILE_CODE_FAILURE = 'GET_MOBILE_CODE_FAILURE';

function getMobileCode(params) {
  return {
    [CALL_API]: {
      types: [GET_MOBILE_CODE_REQUEST, GET_MOBILE_CODE_SUCCESS, GET_MOBILE_CODE_FAILURE],
      endpoint: 'login/get-mobile-code',
      params,
      errHandle: false
    }
  };
}

export default (params) => {
  return (dispatch, getState) => {
    return dispatch(getMobileCode(params));
  };
};


// WEBPACK FOOTER //
// ./src/action/login/getMobileCode.js